import {
    Box,
    VStack,
    Text,
    Input,
    Button,
    Image,
    Select,
    createListCollection,
} from "@chakra-ui/react";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import routes from "../../../../routes";
import Logo from "../../../../assets/logo.png";

import FormLabel from "../../components/FormLabel";
import { updateProfileAction } from "../../../../state/actions/authActions";

import { toaster } from "../../../../components/toaster";
import ActivityToast from "../../../../components/ActivityToast";
import { districtOptions } from "../../../../utils/districtOptions";

const FillPersonalDetailsForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { user, updatingProfile } = useSelector(
        (state) => state.auth
    );

    const [firstName, setFirstName] = useState(
        user?.first_name || ""
    );

    const [lastName, setLastName] = useState(
        user?.last_name || ""
    );


    const [district, setDistrict] = useState(
        user?.district || ""
    );

    const districtCollection = createListCollection({
    items: districtOptions,
});
    const handleSubmit = async () => {
        if (
            !firstName.trim() ||
            !lastName.trim() ||
            !district.trim()
        ) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Missing Information"
                        description="Please complete all personal details before continuing."
                        timestamp="Just now"
                    />
                ),
            });

            return;
        }

        const result = await dispatch(
            updateProfileAction({
                first_name: firstName.trim(),
                last_name: lastName.trim(),
                district: district.trim(),
            })
        );

        if (result?.success) {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="success"
                        title="Personal Details Saved"
                        description="Your personal details have been saved successfully."
                        timestamp="Just now"
                    />
                ),
            });

            setTimeout(() => {
                navigate(routes.dashboard);
            }, 700);
        } else {
            toaster.create({
                render: () => (
                    <ActivityToast
                        type="error"
                        title="Update Failed"
                        description={
                            result?.error ||
                            "Unable to save your personal details."
                        }
                        timestamp="Just now"
                    />
                ),
            });
        }
    };

    const isValid =
        firstName.trim() &&
        lastName.trim() &&
        district.trim();

    return (
        <Box
            p={{
                base: 6,
                md: 10,
                lg: 20,
            }}
            overflowY="auto"
            h="100vh"
        >
            {/* HEADER */}
            <Box
                textAlign="center"
                mb={10}
            >
                <Image
                    src={Logo}
                    h="52px"
                    mx="auto"
                    mb={12}
                />

                <Text
                    fontSize={{
                        base: "36px",
                        md: "48px",
                    }}
                    fontWeight="700"
                    color="#071D54"
                >
                    Personal Details
                </Text>

                <Text
                    mt={3}
                    color="gray.600"
                    maxW="500px"
                    mx="auto"
                    fontSize="md"
                >
                    Tell us a little about yourself before
                    you continue using Mogoma.
                </Text>
            </Box>

            {/* FORM */}
            <VStack
                gap={6}
                align="stretch"
                maxW="650px"
                mx="auto"
            >
                {/* FIRST NAME */}
                <Box>
                    <FormLabel>
                        First Name
                    </FormLabel>

                    <Input
                        size="lg"
                        placeholder="Enter your first name"
                        value={firstName}
                        onChange={(e) =>
                            setFirstName(
                                e.target.value
                            )
                        }
                    />
                </Box>

                {/* LAST NAME */}
                <Box>
                    <FormLabel>
                        Last Name
                    </FormLabel>

                    <Input
                        size="lg"
                        placeholder="Enter your last name"
                        value={lastName}
                        onChange={(e) =>
                            setLastName(
                                e.target.value
                            )
                        }
                    />
                </Box>

                

                {/* DISTRICT */}
                <Box>
    <FormLabel>
        District
    </FormLabel>

    <Select.Root
        collection={districtCollection}
        value={district ? [district] : []}
        onValueChange={(e) => {
            setDistrict(e.value[0] || "");
        }}
        size="lg"
    >
        <Select.Trigger>
            <Select.ValueText
                placeholder="Select your district"
            />
            <Select.Indicator />
        </Select.Trigger>

        <Select.Content>
            {districtCollection.items.map((item) => (
                <Select.Item
                    key={item.value}
                    item={item}
                >
                    {item.label}
                </Select.Item>
            ))}
        </Select.Content>
    </Select.Root>
</Box>

                {/* BUTTON */}
                <Button
                    mt={3}
                    size="lg"
                    bg="#2453FF"
                    color="white"
                    loading={updatingProfile}
                    loadingText="Saving..."
                    disabled={!isValid}
                    _hover={{
                        bg: "#1E46D8",
                    }}
                    onClick={handleSubmit}
                >
                    Continue
                </Button>

                <Text
    textAlign="center"
    fontSize="sm"
    color="gray.500"
>
    Make sure the names you enter match the names
    appearing on your Omang or passport document.
</Text>
            </VStack>
        </Box>
    );
};

export default FillPersonalDetailsForm;